// packages import
import { Button, CircularProgress, DialogActions, Typography } from '@mui/material'
import { FC } from 'react'

// component import
import { CustomModal } from '../../common/CustomModal'

// others
import { CANCEL } from '../../../constants'
import { GetTrustBalanceSummaryQuery } from '../../../../generated'
import { formatCurrency } from '../../../utils'

interface ConfirmCloseMatterModalProps {
  isOpen: boolean
  clients: GetTrustBalanceSummaryQuery['getTrustBalanceSummary']['ioltaBalanceSummary']['clients']
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmCloseMatterModal: FC<ConfirmCloseMatterModalProps> = ({
  isOpen,
  clients,
  loading = false,
  onClose,
  onConfirm
}) => {
  const clientsCount = clients.length
  const clientNamesWithBalances = clients.map(client => `${client.name} (${formatCurrency(client.trustBalance || 0)})`)

  return (
    <CustomModal title="Confirm Close Matter" isOpen={isOpen} handleClose={onClose}>
      <Typography variant="body1" mb={2}>
        This will:
      </Typography>

      <Typography component="ul" sx={{ pl: 3, mb: 2 }}>
        <Typography component="li" variant="body1">
          Generate {clientsCount} settlement check{clientsCount > 1 ? 's' : ''} for {clientNamesWithBalances.join(', ')}
        </Typography>
        <Typography component="li" variant="body1">
          Mark the matter as closed
        </Typography>
      </Typography>

      <Typography variant="body1">Do you want to continue?</Typography>

      <DialogActions sx={{ padding: '20px 0 0', gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          {CANCEL}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
        >
          Yes, Continue
        </Button>
      </DialogActions>
    </CustomModal>
  )
}
